module.exports = __webpack_public_path__ + "static/media/yanuar.9a3fa06a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/image/Team/yanuar.jpg
// module id = 171
// module chunks = 0